import { Button, EmptyState, LoadingState } from '@osteopro/ui';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '../../lib/error-messages.js';

/**
 * Les états de chargement et d'erreur d'un panneau, écrits une fois. Tout écran doit les trois —
 * chargement, erreur, vide — mais seul le vide dépend de ce qu'il liste, et reste donc chez lui.
 *
 * Ils vivent ici et non chez les réglages, qui les ont vus naître : les écrans de plateforme les
 * rendent aussi, et un composant partagé rangé chez l'un de ses appelants finit par lui emprunter
 * ses dépendances — c'est le motif déjà écrit pour `ConfirmDialog`.
 */

export function SectionLoading() {
  return (
    <div data-testid="state-loading">
      {/* Une seule carte formulaire : titre + lignes de champs, pas deux dalles anonymes. */}
      <LoadingState type="card" count={1} />
    </div>
  );
}

export function SectionError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={AlertTriangle}
      title={t('common:errors.title')}
      description={errorMessage(error, t)}
      data-testid="state-error"
      action={
        <Button variant="outline" onClick={onRetry} data-testid="button-retry">
          {t('common:actions.retry')}
        </Button>
      }
    />
  );
}
